import { client } from "api";

export type SetFollowUpDoneRequest = { orderId: string; followUpDone: boolean };
export type SetFollowUpDoneResponse = { orderId: string; followUpDone: boolean };

export const setFollowUpDone = (params: SetFollowUpDoneRequest) =>
  client.post<SetFollowUpDoneResponse>(`/order/setfollowupdone`, params).then((res) => res.data);
